<template>
  <div class="exterior-container">

    <div class="title-with-selector h3-selector">
      <h3 class="subtitle"><b>{{'Slide Exterior ' + exterior.order}}</b></h3>
      <state-selector :selected="exterior ? parseInt(exterior.state) : null" 
                      :target="exterior"
                      :update="'exterior'" 
      ></state-selector>
    </div>

    <div class="columns">
      <div class="column is-3">
        <span><b>Imagem [PT]</b></span>
        <figure class="image coach-image">
          <img v-if="images.pt" :src="images.pt">
        </figure>
      </div>

      <div class="column is-3">
        <span><b>Imagem [EN]</b></span>
        <figure class="image is16by9 coach-image">
          <img v-if="images.en" :src="images.en">
        </figure>
      </div>

      <div class="column is-3">
        <span><b>Imagem [ES]</b></span>
        <figure class="image coach-image">
          <img v-if="images.es" :src="images.es">
        </figure>
      </div>

      <div class="column is-3">
        <span><b>Imagem [FR]</b></span>
        <figure class="image coach-image">
          <img v-if="images.fr" :src="images.fr">
        </figure>
      </div>
    </div>

    <p class="control has-addons">
      <b class="inline-lable">Posição:</b>
      <a class="button is-small"
         :class="{'is-disabled' : exterior.order == 1}"
         @click="reorderExteriors(1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-double-up"></i>
        </span>
        <span>Topo</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : exterior.order == 1}"
         @click="reorderExteriors(parseInt(exterior.order) - 1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-up"></i>
        </span>
        <span>-1</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : exterior.order == exteriorTotal}"
         @click="reorderExteriors(parseInt(exterior.order) + 1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-down"></i>
        </span>
        <span>+1</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : exterior.order == exteriorTotal}"
         @click="reorderExteriors(exteriorTotal)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-double-down"></i>
        </span>
        <span>Fundo</span>
      </a>
    </p>

    <a class="button is-small is-primary" @click="openExteriorEditModal">
      <span class="icon is-small">
        <i class="fa fa-edit"></i>
      </span>
      <span>Editar</span>
    </a>
    <a class="button is-small is-danger" @click="openExteriorDeleteModal">
      <span class="icon is-small">
        <i class="fa fa-trash"></i>
      </span>
      <span>Apagar</span>
    </a>

    <hr>
  </div>
</template>

<script>
  import Vue from 'vue'
  import ExteriorEditModal from './ExteriorEditModal'
  import ExteriorDeleteModal from './ExteriorDeleteModal'

  import StateSelector from '../Util/StateSelector'
  import { EXTERIOR_IMG_PATH } from '../../config'

  const ExteriorEditModalComponent = Vue.extend(ExteriorEditModal)
  const ExteriorDeleteModalComponent = Vue.extend(ExteriorDeleteModal)

  export default {
    components: {
      StateSelector
    },

    props: {
      exterior: Object,
      exteriorTotal: Number
    },

    data () {
      return {
        coachId: this.$store.state.route.params.id,
        exteriorImagePath: EXTERIOR_IMG_PATH,
        mounted: false,
        images: {
          pt: null,
          en: null,
          es: null,
          fr: null
        }
      }
    },

    mounted () {
      this.mounted = true
      this.setImages()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      reorderExteriors (newPosition) {
        this.$store.dispatch('reorderExteriors', {coach: this.coachId, exterior: this.exterior, position: newPosition})
      },

      setImages () {
        for (let image of this.exterior.images) {
          this.images[image.lang] = image.imageUrl
        }
      },

      openExteriorEditModal () {
        let openCardModalExterior = (propsData = {}) => {
          return new ExteriorEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModalExterior({
          title: 'Editar Exterior',
          exteriorTotal: this.exteriorTotal,
          exteriorData: this.exterior
        })
      },
      openExteriorDeleteModal () {
        let openCardModalExterior = (propsData = {}) => {
          return new ExteriorDeleteModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModalExterior({
          title: 'Apagar Exterior',
          id: parseInt(this.exterior.exteriorId)
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      },
      exterior: function (val) {
        this.setImages()
      }
    }
  }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// ExteriorCard.vue?54940a03